import { render } from "./ResetPasswordVerify.vue?vue&type=template&id=41bd8ac5&scoped=true"
import script from "./ResetPasswordVerify.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordVerify.vue?vue&type=script&lang=ts"

import "./ResetPasswordVerify.vue?vue&type=style&index=0&id=41bd8ac5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41bd8ac5"

export default script